import { useContext } from "react"
import { HistoricoVersoesContext } from "./HistoricoVersoesContext"

export function useHistoricoVersoesContext() {
    return useContext(HistoricoVersoesContext)
}
